import Vue from 'vue'
import en from './en'
import zh from './zh'
import fr from './fr'
import de from './de'
import es from './es'
import ja from './ja'
import ms from './ms'
import id from './id'
import tl from './tl'

const messages = {en, zh, fr, de, es, ja, ms, id, tl}
const STORAGE_KEY = 'appLocale'
const DEFAULT_LOCALE = 'en'

// Reactive holder so $t re-evaluates when locale changes.
const state = new Vue({
    data() {
        return {
            locale: DEFAULT_LOCALE
        }
    }
})

const browserLocaleMap = {
    zh: 'zh',
    fr: 'fr',
    de: 'de',
    es: 'es',
    ja: 'ja',
    ms: 'ms',
    id: 'id',
    tl: 'tl',
    fil: 'tl'
}

function detectBrowserLocale() {
    const nav = (navigator.language || '').toLowerCase()
    for (const prefix in browserLocaleMap) {
        if (nav.indexOf(prefix) === 0) {
            const mapped = browserLocaleMap[prefix]
            if (messages[mapped]) {
                return mapped
            }
        }
    }
    return null
}

function loadStoredLocale() {
    try {
        const stored = localStorage.getItem(STORAGE_KEY)
        if (stored && messages[stored]) {
            state.locale = stored
            return
        }
        const detected = detectBrowserLocale()
        if (detected) {
            state.locale = detected
        }
    } catch (e) {
        // localStorage may be unavailable (private mode); fall back to default.
    }
}

function lookup(locale, key) {
    const parts = key.split('.')
    let val = messages[locale]
    for (let i = 0; i < parts.length; i++) {
        if (val == null) {
            return undefined
        }
        val = val[parts[i]]
    }
    return val
}

function translate(key, params) {
    let raw = lookup(state.locale, key)
    if (raw == null) {
        // Fall back to English, then to the key itself.
        raw = lookup(DEFAULT_LOCALE, key)
    }
    if (raw == null) {
        return key
    }
    if (typeof raw !== 'string') {
        return key
    }
    if (params) {
        return raw.replace(/\{(\w+)\}/g, function (m, name) {
            return params[name] != null ? String(params[name]) : m
        })
    }
    return raw
}

const i18n = {
    get locale() {
        return state.locale
    },
    set locale(value) {
        if (!messages[value]) {
            return
        }
        state.locale = value
        try {
            localStorage.setItem(STORAGE_KEY, value)
        } catch (e) {
            // ignore
        }
    },
    get messages() {
        return messages
    },
    t: translate,
    install() {
        Vue.prototype.$i18n = this
        // Use a function getter so templates re-evaluate against the reactive state.
        Object.defineProperty(Vue.prototype, '$t', {
            get() {
                return (key, params) => translate(key, params)
            }
        })
    }
}

loadStoredLocale()

export default i18n
